import { Form, Input, Modal, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useUpdateQuestionSummary } from '../../../../api/CodeFrames';
import { summaryType } from '../../../../types';

const { TextArea } = Input;

function EditQuestionSummaryModal({ visible, closeModal, summary, codeFrameId, surveyId }) {
  const [form] = Form.useForm();
  const { mutate: updateQuestionSummary, isLoading: updateQuestionSummaryLoading } =
    useUpdateQuestionSummary();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ summary: summary.summary, theme_overview: summary.theme_overview });
    }
  }, [form, summary, visible]);

  const onFinish = (values) => {
    updateQuestionSummary(
      {
        codeFrameId,
        surveyId,
        data: { summary: values.summary, theme_overview: values.theme_overview },
      },
      {
        onSuccess: () => message.success('Question summary updated'),
        onSettled: () => closeModal(),
      },
    );
  };

  return (
    <Modal
      title="Edit question summary"
      open={visible}
      width={600}
      onOk={() => {
        form
          .validateFields()
          .then(onFinish)
          .catch(() => {});
      }}
      okText="Update"
      onCancel={closeModal}
      confirmLoading={updateQuestionSummaryLoading}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          name="summary"
          label="Summary"
          rules={[
            { required: true, message: 'Question summary is required' },
            { whitespace: true, message: 'Question summary cannot be blank' },
          ]}
        >
          <TextArea rows="6" />
        </Form.Item>
        <Form.Item
          name="theme_overview"
          label="Theme overview"
          rules={[
            { required: true, message: 'Theme overview is required' },
            { whitespace: true, message: 'Theme overview cannot be blank' },
          ]}
        >
          <TextArea rows="6" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

EditQuestionSummaryModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  summary: summaryType.isRequired,
  codeFrameId: PropTypes.number.isRequired,
  surveyId: PropTypes.number.isRequired,
};

export default EditQuestionSummaryModal;
